import { useState } from "react"

const Modal = ({ open, handleClose }) => {
  const [campoEmail, setCampoEmail] = useState("")
  const [campoPassword, setCampoPassword] = useState("")
  
  const handleModalAceptar = (e) => {
    e.preventDefault()
    handleClose();
    setCampoEmail("")
    setCampoPassword("")
  }

  const hadleModalCancelar = (e) => {
    e.preventDefault()
    setCampoPassword("")
    setCampoEmail("")
  }

  const handleEmail = (e) => {
    setCampoEmail(e.target.value)
  }

  const handlePassword = (e) => {
    setCampoPassword(e.target.value)
  }

  return (
    <div>
    {open && (
    <form className="tw-shadow-color: #fff fixed inset-0 bg black bg opacity 30 backdrop-blur-sm flex justify-center items-center">
      <div className="bg-white p-5 rouded flex flex-col justify-center items-center gap-5 rounded shadow-2xl">
        <div>
          <label className="mr-3 font-semibold font-[Poppins]">Email</label> 
          <input 
           type="email"
           placeholder="Email"
           className="w-64 px-4 border-2 border-gray-300 rounded-lg focus:outline-none"
           onChange={handleEmail}
           value={campoEmail}
           />  
        </div>
        <div>
          <label className="mr-3 font-semibold font-[Poppins]">Password</label> 
          <input 
           type="password"
           placeholder="Password"
           className="w-64 px-4 border-2 border-gray-300 rounded-lg focus:outline-none"
           onChange={handlePassword}
           value={campoPassword}
           />  
        </div>
        <button 
          className="bg-red-500 hover:bg-red-700 py-2 px-6 text-white font-bold m-5 rounded shadow-md"
          onClick={handleModalAceptar}
          >
            Aceptar
        </button>
        <button
          className="bg-red-500 hover:bg-red-700 py-2 px-6 text-white font-bold m-5 rounded shadow-md"
          onClick={hadleModalCancelar}
        >
           Cancelar
        </button>
      </div>
    </form>
    )}
    </div>
  )  
}

export default Modal